import React, {
  useRef, useEffect, useContext,
} from 'react';
import { Animated } from 'react-native';

import { ScrollViewContext } from './ScrollViewContext';
import { DragAndDropContext, STATUS } from './DragAndDropContext';
import { DraggableFlatListContext } from './DraggableFlatListContext';


export const AutoScrollContext = React.createContext({
  draggedItem: null,
  setDraggedItem: () => {},
  translateY: new Animated.Value(0),
});

const SCROLL_THRESHOLD = 150;

export const { Consumer } = AutoScrollContext;


export const Provider = ({
  children,
}) => {
  const { contentOffset, layout } = useContext(ScrollViewContext),
        { touchStatus } = useContext(DragAndDropContext),
        {
          scrollViewComponent,
          onPanGestureEvent,
        } = useContext(DraggableFlatListContext);

  const layoutHeight = useRef(0),
        lastScroll = useRef(new Date()),
        localTouchStatus = useRef(STATUS.INACTIVE),
        contentOffsetY = useRef(0);

  useEffect(() => {
    const forkEventCallback = ({ nativeEvent }) => {
      const value = nativeEvent.y;

      if (lastScroll.current.valueOf() + 200 > new Date().valueOf()) {
        return;
      }

      if (localTouchStatus.current === STATUS.DRAGGED) {
        const node = scrollViewComponent.current.getNode();
        if (value < SCROLL_THRESHOLD && contentOffsetY.current > 0) {
          const diff = SCROLL_THRESHOLD + Math.abs(value - SCROLL_THRESHOLD);
          node.scrollToOffset({
            offset: contentOffsetY.current - diff,
            animated: true,
          });
          lastScroll.current = new Date();
        } if (value > layoutHeight.current - SCROLL_THRESHOLD) {
          const diff = SCROLL_THRESHOLD + Math.abs(
            value + SCROLL_THRESHOLD - layoutHeight.current,
          );
          node.scrollToOffset({
            offset: contentOffsetY.current + diff,
            animated: true,
          });
          lastScroll.current = new Date();
        }
      }
    };

    Animated.forkEvent(onPanGestureEvent, forkEventCallback);
    return () => {
      Animated.unforkEvent(onPanGestureEvent, forkEventCallback);
    };
  }, [onPanGestureEvent, scrollViewComponent]);

  useEffect(() => {
    contentOffsetY.current = contentOffset.current.y;
    layoutHeight.current = layout.height;
    localTouchStatus.current = touchStatus;
  }, [contentOffset, layout.height, touchStatus]);

  return (
    <AutoScrollContext.Provider>
      {children}
    </AutoScrollContext.Provider>
  );
};

export default { Consumer, Provider };
